import React from 'react';
import { KEY } from 'util/Input';

export const handleKeyDownOnEnter = <T, A>(event: React.KeyboardEvent<HTMLElement>, actionAfterEnter: Fn<T, A>) => {
  if (event.key === KEY.ENTER) actionAfterEnter();
};

export const handleOnClick = <T, A>(event: React.MouseEvent<HTMLElement>, actionAfterClick: Fn<T, A>) => {
  event.stopPropagation();
  actionAfterClick();
};
